module.exports = __webpack_public_path__ + "fonts/Poppins-BoldItalic.5bda2710.ttf";